<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    class="save-icon"
  >
    <path d="M21 7L9 19l-5.5-5.5l1.41-1.41L9 16.17L19.59 5.59z" />
  </svg>
</template>

<script>
export default {
  name: 'SaveIcon',
}
</script>

<style scoped>
.save-icon {
  width: 24px;
  height: 24px;
}
</style>
